import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL as string;

export const api = axios.create({ baseURL: `${BASE}/api` });

export function setToken(token: string | null) {
  if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete api.defaults.headers.common.Authorization;
}

let refreshing: Promise<string | null> | null = null;

async function tryRefresh(): Promise<string | null> {
  const rt = localStorage.getItem("nx_refresh");
  if (!rt) return null;
  try {
    const { data } = await axios.post(`${BASE}/api/auth/refresh`, { refresh_token: rt });
    localStorage.setItem("nx_token", data.access_token);
    localStorage.setItem("nx_refresh", data.refresh_token);
    localStorage.setItem("nx_user", JSON.stringify(data.user));
    setToken(data.access_token);
    return data.access_token;
  } catch {
    return null;
  }
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const isAuthCall = (original?.url || "").includes("/auth/login") || (original?.url || "").includes("/auth/refresh");
    if (error.response?.status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      refreshing = refreshing || tryRefresh();
      const token = await refreshing;
      refreshing = null;
      if (token) {
        original.headers.Authorization = `Bearer ${token}`;
        return api(original);
      }
      localStorage.removeItem("nx_token");
      localStorage.removeItem("nx_refresh");
      localStorage.removeItem("nx_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export function apiError(e: any): string {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d))
    return d
      .map((x: any) => {
        const champ = (x?.loc || []).slice(1).filter((p: any) => typeof p === "string").join(".");
        return `${champ ? champ + " : " : ""}${x?.msg || "valeur invalide"}`;
      })
      .join(" · ");
  if (typeof d === "string") return d;
  return e?.message || "Erreur inattendue";
}
